import { lazy } from 'react';

export default lazy(() =>
  import(
    /* webpackChunkName: 'sign_up_confirmation_page' */ './ConfirmationPage'
  ),
);
